<mat-card>
  <mat-card-header>
    <mat-card-title>
      <span class="font-semibold text-xl">In Home Care Reports</span>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="flex flex-col pt-4 portal-actions">
      <span class="font-semibold text-lg">Select a Report</span>
      <mat-form-field>
        <mat-label>Reports</mat-label>
        <mat-select [(ngModel)]="selectedReport">
          <mat-option value="AppStatus">Application Status</mat-option>
          <mat-option value="Expiration">Expired Agencies</mat-option>
          <mat-option value="Closed">Closed Agencies</mat-option>
          <mat-option value="DateIssued">Issued Date</mat-option>
          <mat-option value="County">Agencies by County</mat-option>
          <mat-option value="City">Agencies by City</mat-option>
          <mat-option value="Subunit">Agency Subunits</mat-option>
          <mat-option value="Branch">Agency Branches</mat-option>
          <mat-option value="Classification">Agencies by Classification</mat-option>
          <mat-option value="Admin">Administrators</mat-option>
          <mat-option value="Owner">Owners</mat-option>
          <mat-option value="AgencyName">Agency Name</mat-option>
          <mat-option value="BackgroundCheck">Background Check</mat-option>
          <mat-option value="Payment">Payments</mat-option>
          <mat-option value="RegisteredNurse">Registered Nurses</mat-option>
          <mat-option value="QualifiedEntity">Qualified Entities</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-button type="button" color="primary" (click)="downloadDocument()">Download Selected Report</button>
    </div>
  </mat-card-content>
</mat-card>
